var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar"},[_c('div',{staticClass:"d-flex"},[_c('BackToProposal'),_c('AddArchitecture'),_c('AddFromTemplate'),_c('AutogenerateArchitecture')],1),_c('div',[_c('RefreshData')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }